import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * useIsTouchOnlyDevice
 *
 * Detects whether the user is on a touch-only device (touch input without hover capability).
 *
 * - This will return `false` for devices that have both touch and hover (e.g., laptops with touchscreens,
 *   tablets with mouse/trackpad, or hybrid devices). These devices support hover via their pointing device,
 *   so they should use hover-based interactions rather than touch-only interactions.
 * - This will return `true` for devices like phones and tablets that are primarily touch-only.
 *
 * Live, not captured once: dev-tools device emulation switches these capabilities mid-session, and a
 * stale reading disagreeing with a component's own live media query is how FE-574 crashed the page.
 *
 * @returns Boolean indicating if the device is touch-only (no hover capability)
 */
export function useIsTouchOnlyDevice() {
  return useMediaQuery('(hover: none) and (pointer: coarse)')
}
